import { useEffect, useState } from "react";
import {
  POSITION_MANAGER_ADDRESS,
  positionManagerABI,
} from "../../../Ethereum/Constant/addresses.js";
import { Contract } from "ethers";

import { NavLink, useParams } from "react-router-dom";
import * as API from "../../../Utils/Services/api";
import translation from "../../Translations/translation.json";
import "./ViewPositions.css";
import { useLanguage } from "../../LanguageContext";
import { toast } from "react-toastify";
import SeoJson from "../../SeoJson";
import { Helmet } from "react-helmet-async";
import Loading from "../../Loading/Loading";
import { contractInstance } from "../../../Ethereum/Connect/config";
import ViewPositionsV3 from "./ViewPositionsV3.jsx";
import { Dropdown } from "react-bootstrap";

const ViewPositions = () => {
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };

  const { walletAddress } = useParams();
  const [selectedVersion, setSelectedVersion] = useState("v3");
  const [viewPositionsLoading, setViewPositionsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [v3Positions, setV3Positions] = useState([]);

  const [liquidityCreated, setLiquidityCreated] = useState([]);
  const { toggleLanguage, language } = useLanguage();
  const url = `https://powdex.io/pool/${walletAddress}`;

  const title = `${translate("titleBar.viewPositions")}`;
  // "My Liquidity Positions — ETHW Pools | PoWDex";
  const desc =
    "View all your liquidity positions on PoWDex. Track pools you’ve created on EthereumPoW (ETHW), including token pairs, share, and earnings.";

  const [showAllLiquidity, setShowAllLiquidity] = useState(false);
  const showLiquidity = (i) => {
    setShowAllLiquidity((prevIndex) => (prevIndex === i ? null : i));
  };

  const getAllLiquidityDetail = async () => {
    try {
      setViewPositionsLoading(true);
      const resp = await API.getAllLiquidityPools(walletAddress);

      setLiquidityCreated(resp.data?.tokens);
      setViewPositionsLoading(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "An error occurred");
      setLiquidityCreated(null);
      setViewPositionsLoading(false);
    } finally {
      setViewPositionsLoading(false);
    }
  };

  // useEffect(() => {
  //   getAllLiquidityDetail();
  // }, []);
  const handleCopy = (address) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        toast.success(`${translate("copiedSuccessfully")}`);
        // toast.success("Copied Successfully");
      })
      .catch((err) => {
        toast.error("Error");
      });
  };
  const handleVersionChange = async (version) => {
    setSelectedVersion(version);

    if (version === "v2") {
      // getAllLiquidityDetail();
    } else if (version === "v3") {
      // try {
      //   setViewPositionsLoading(true);
      //   const resp = await API.getAllLiquidityPools(walletAddress);
      //   setLiquidityCreated(resp.data?.tokens || []);
      // } catch (err) {
      //   toast.error(err.response?.data?.message || "An error occurred");
      //   setLiquidityCreated([]);
      // } finally {
      //   setViewPositionsLoading(false);
      // }
    }
    // if (version === "v2") {
    //   getAllLiquidityDetail();
    // } else if (version === "v3") {
    //   // Option A: fetch V3 positions on-chain
    //   await fetchV3Positions();
    //   // Option B: also fetch API-provided v3 mirror if you want combined data
    // }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={url} />

        {/* OG / Twitter */}
        <meta property="og:site_name" content="PoWDex" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content="https://powdex.io/og-pools.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <main className="main-divi">
        <div
          className={`section-bg view-positions-pg view-positions-pg-height ${
            liquidityCreated && liquidityCreated.length > 3
              ? "length-more"
              : "length-less"
          }`}
          // style={
          //   liquidityCreated && liquidityCreated.length > 2
          //     ? { height: "100%" }
          //     : { height: "90vh" }
          // }
        >
          <div className="gradient-bg-circle-2"> </div>
          <div className="gradient-bg-circle"></div>
          <div className="container">
            <div className="page-width-vp">
              <div className="vp-pg">
                <div className="view-positions-heading">
                  <h2>{translate("viewPositions.heading")}</h2>
                  {/* <div className="dropdown">
                    <button
                      className="btn dropdown-btn-pool"
                      type="button"
                      onClick={() => setIsDropdownOpen((prev) => !prev)}
                    >
                      {selectedVersion}
                      <i className="fa fa-angle-down ms-1"></i>
                    </button>
                    {isDropdownOpen && (
                      <ul
                        className="dropdown-menu show"
                        style={{ display: "block", position: "absolute" }}
                      >
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              handleVersionChange("v2");
                              setIsDropdownOpen(false);
                            }}
                          >
                            v2
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              handleVersionChange("v3");
                              setIsDropdownOpen(false);
                            }}
                          >
                            v3
                          </button>
                        </li>
                      </ul>
                    )}
                  </div> */}
                  {/* <div className="view-positions-optn-btns">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="none"
                        id="version-dropdown"
                        className="btn text-light add-liquidity-sel-token modal-btn-back-css"
                      >
                        {selectedVersion}
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="dropdown-menu-selection-v2-v3">
                        <Dropdown.Item onClick={() => setSelectedVersion("v2")}>
                          {translate("addLiquidity.newv2Position")}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedVersion("v3")}>
                          {translate("addLiquidity.newv3Position")}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div> */}
                </div>
                {selectedVersion === "v2" ? (
                  <div className="navlink-a-btn-migrate">
                    <NavLink to="/migrate" className="migrate-btn-a">
                      <button className="migrate-btn">
                        {translate("viewPositions.migrate")}
                        <i className="fa fa-angle-double-right fa-xs"></i>
                      </button>
                    </NavLink>
                    <NavLink to="/createPool">
                      <button className="new-positions-btn new-positions-relative">
                        <i className="fa fa-plus me-1 fa-xs"></i>{" "}
                        {translate("viewPositions.newposition")}
                      </button>
                    </NavLink>
                  </div>
                ) : (
                  <>
                    <div className="navlink-a-btn-migrate">
                      <NavLink to="/createPool">
                        <button className="new-positions-btn new-positions-relative">
                          <i className="fa fa-plus me-1 fa-xs"></i>{" "}
                          {translate("viewPositions.newposition")}
                        </button>
                      </NavLink>
                    </div>
                  </>
                )}
              </div>{" "}
              <div className="selected-content">
                {selectedVersion === "v3" ? (
                  <>
                    {/* <p>{translate("viewPositions.descriptionv3")}</p>{" "} */}
                    {/* {v3Positions.length > 0 ? (
                      v3Positions.map((p, idx) => (
                        <div key={idx} className="view-liquidi">
                          <div className="view-created-liquidity">
                            <div className="created-liquidity-img">
                              You may need to fetch token metadata (symbol,
                              image) separately
                              <span>TokenID: {p.tokenId}</span>
                            </div>
                            <div>
                              show balances/amounts if pos holds them or call
                              helper to format
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: "center" }}>
                        {translate("viewPositions.descriptionv3")}
                      </p>
                    )} */}
                    <ViewPositionsV3 />
                  </>
                ) : (
                  <>
                    {liquidityCreated?.length > 0 ? (
                      <>
                        <div className="account-analytics">
                          <p>
                            {translate("viewPositionsHeading.accountAnalytics")}
                          </p>
                          {/* <p>Account analytics</p> */}
                          {liquidityCreated.map((item, i) => (
                            <div
                              key={i}
                              className="view-liquidi"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="view-created-liquidity">
                                <div className="created-liquidity-img">
                                  <img
                                    className="created-liquidity-img-mt"
                                    src={item.image}
                                    alt=""
                                  />
                                  <span className=""> {item?.name}</span>
                                </div>
                                <div onClick={() => showLiquidity(i)}>
                                  <button className="manage-liquidity-btn">
                                    {item?.ethwAmount}/ {item?.tokenAmount}
                                    {/* <i className="fa fa-angle-down ms-1"></i> */}
                                  </button>
                                </div>
                              </div>
                              {/* {showAllLiquidity === i && ( */}
                              <div className="manage-all-liquidity">
                                <div className="liquidty-info">
                                  <div className="liquidity-info-title">
                                    {/* Token address: */}
                                    {translate(
                                      "viewPositionsHeading.tokenAddress"
                                    )}
                                  </div>
                                  <div className="liquidity-info-amt">
                                    {item.address.slice(0, 6)}...
                                    {item.address.slice(-5)}
                                    <i
                                      className="fa fa-copy ms-1"
                                      onClick={() => handleCopy(item.address)}
                                    ></i>
                                  </div>
                                </div>
                                <div className="liquidty-info">
                                  <div className="liquidity-info-title">
                                    {/* Pool address: */}
                                    {translate(
                                      "viewPositionsHeading.poolAddress"
                                    )}
                                  </div>
                                  <div className="liquidity-info-amt">
                                    {item.poolAddress.slice(0, 6)}...
                                    {item.poolAddress.slice(-5)}
                                    <i
                                      className="fa fa-copy ms-1"
                                      onClick={() =>
                                        handleCopy(item.poolAddress)
                                      }
                                    ></i>
                                  </div>
                                </div>{" "}
                                <div className="liquidty-info">
                                  <div className="liquidity-info-title">
                                    {/* Pool address: */}
                                    {translate(
                                      "viewPositionsHeading.pairAddress"
                                    )}
                                  </div>
                                  <div className="liquidity-info-amt">
                                    {item.pairAddress.slice(0, 6)}...
                                    {item.pairAddress.slice(-5)}
                                    <i
                                      className="fa fa-copy ms-1"
                                      onClick={() =>
                                        handleCopy(item.pairAddress)
                                      }
                                    ></i>
                                  </div>
                                </div>
                                <div className="liquidty-info">
                                  <div className="liquidity-info-title">
                                    {/* Pooled ETHW: */}
                                    {translate(
                                      "viewPositionsHeading.pooledEthw"
                                    )}
                                  </div>
                                  <div className="liquidity-info-amt">
                                    {item.ethwAmount}
                                    {/* <img
                                        className="ms-1"
                                        src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1736146653/AFH/HomeImage/null_main_1736146653551.jpg"
                                        alt=""
                                      /> */}
                                  </div>
                                </div>
                                <div className="liquidty-info">
                                  <div className="liquidity-info-title">
                                    {/* Pooled tokens: */}
                                    {translate(
                                      "viewPositionsHeading.pooledTokens"
                                    )}
                                  </div>
                                  <div className="liquidity-info-amt">
                                    {item.tokenAmount}
                                    {/* <img
                                        className="ms-1"
                                        src={item.imageUrl}
                                        alt=""
                                      /> */}
                                  </div>
                                </div>
                                {/* <div className="liquidty-info">
                              <div className="liquidity-info-title">
                                Your pool share
                              </div>
                              <div className="liquidity-info-amt">0.30%</div>
                            </div> */}
                              </div>
                              {/* )} */}
                            </div>
                          ))}
                        </div>
                      </>
                    ) : viewPositionsLoading ? (
                      <Loading />
                    ) : (
                      <p style={{ textAlign: "center" }}>
                        {translate("viewPositions.descriptionv2")}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ViewPositions;
